import Filter from "./Filter";
import FormData from "./FormData";
import ListData from "./ListData";
import TableData from "./TableData";
import MoveFolder from "./MoveFolder";
import FormAttachment from "./FormAttachment";
import DetailData from "./DetailData";

const vaultComponents = {
  Filter,
  FormData,
  ListData,
  TableData,
  MoveFolder,
  FormAttachment,
  DetailData
}

export default vaultComponents